module.exports = __webpack_public_path__ + "img/ability-3.758ac701.png";